var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3521 1.33325C11.3621 1.33325 12.2855 1.90392 12.7372 2.80735L14.2445 5.822C14.5223 6.37742 14.6668 6.98988 14.6668 7.61086V13.3333C14.6668 14.0696 14.0699 14.6666 13.3335 14.6666C12.5971 14.6666 12.0002 14.0696 12.0002 13.3333V11.9999H4.00016V13.3333C4.00016 14.0696 3.40321 14.6666 2.66683 14.6666C1.93045 14.6666 1.3335 14.0696 1.3335 13.3333V7.61086C1.3335 6.98988 1.47808 6.37742 1.75579 5.822L3.26311 2.80735C3.71483 1.90392 4.63819 1.33325 5.64825 1.33325H10.3521ZM12.6668 8.66659H11.3335C10.9653 8.66659 10.6668 8.96506 10.6668 9.33325C10.6668 9.67514 10.9242 9.95692 11.2557 9.99543L11.3335 9.99992H12.6668C13.035 9.99992 13.3335 9.70144 13.3335 9.33325C13.3335 8.99136 13.0761 8.70958 12.7446 8.67107L12.6668 8.66659ZM4.66683 8.66659H3.3335C2.96531 8.66659 2.66683 8.96506 2.66683 9.33325C2.66683 9.67514 2.92419 9.95692 3.25575 9.99543L3.3335 9.99992H4.66683C5.03502 9.99992 5.3335 9.70144 5.3335 9.33325C5.3335 8.99136 5.07614 8.70958 4.74458 8.67107L4.66683 8.66659ZM10.5095 2.66659H5.49087C5.02192 2.66659 4.59034 2.91262 4.35024 3.30943L4.29831 3.40363L2.66683 6.66659H13.3335L11.702 3.40363C11.4762 2.95192 11.0145 2.66659 10.5095 2.66659Z",
    fill: "#059669"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarIcon);
export default __webpack_public_path__ + "static/media/carIcon.8dd0b1c8.svg";
export { ForwardRef as ReactComponent };